import { css } from '@emotion/react';
import {
  forwardRef, type MouseEventHandler,
} from 'react';
import { ButtonComponent } from '~/_shared/baseComponents/buttons/button/button.component';

type LoadBoundaryPaneSubmitButtonComponentProps = Readonly<{
  text: string;
  isDisabled: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}>;

const addBoundaryButtonStyle = css({
  height: '48px',
  width: '100%',
});

export const LoadBoundaryPaneSubmitButtonComponent = forwardRef<HTMLButtonElement, LoadBoundaryPaneSubmitButtonComponentProps>(
  ({
    text,
    isDisabled,
    onClick,
    ...restProps
  }, ref) => {
    return (
      <ButtonComponent
        {...restProps}
        ref={ref}
        css={addBoundaryButtonStyle}
        text={text}
        isDisabled={isDisabled}
        onClick={onClick}
      />
    );
  });
